import { useEffect, useState } from "react";
import { Headphones, MessageSquare, Users, CalendarClock } from "lucide-react";
import api from "@/lib/api";

const fmtDate = (iso) => new Date(iso).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" });

// Billing card: public scene listens over 14 days + per-scene table.
export default function SceneAnalyticsCard() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/voice/share-analytics").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data || data.scenes.length === 0) return null;
  const max = Math.max(1, ...data.days.map((d) => d.plays));
  return (
    <div className="rounded-2xl border border-border bg-card p-6" data-testid="scene-analytics-card">
      <div className="flex items-center justify-between mb-1">
        <h3 className="font-display text-lg font-bold flex items-center gap-2"><Headphones size={18} className="text-secondary" /> Scènes partagées</h3>
        <span className="text-xs font-mono text-muted-foreground" data-testid="scene-analytics-total">{data.total_plays} écoutes · {data.total_listeners ?? 0} auditeurs uniques · {data.total_comments} notes</span>
      </div>
      <p className="text-xs text-muted-foreground mb-4">Écoutes publiques sur 14 jours, auditeurs uniques et retours d'équipe par scène.</p>
      <div className="flex items-end gap-1 h-20" data-testid="scene-analytics-days">
        {data.days.map((d) => (
          <div key={d.day} className="flex-1 flex flex-col items-center justify-end h-full" title={`${d.day} · ${d.plays} écoute(s)`}>
            <div className="w-full rounded-sm bg-secondary/70" style={{ height: `${Math.max(3, (d.plays / max) * 100)}%`, opacity: d.plays ? 1 : 0.25 }} />
            <span className="text-[8px] font-mono text-muted-foreground mt-1">{d.day.slice(8)}</span>
          </div>
        ))}
      </div>
      <div className="mt-4 space-y-1.5" data-testid="scene-analytics-scenes">
        {data.scenes.map((s) => (
          <div key={s.title} className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs rounded-lg bg-background border border-border px-3 py-1.5" data-testid={`scene-analytics-row-${s.title}`}>
            <span className="flex-1 min-w-[8rem] truncate font-medium">{s.title}</span>
            <span className="font-mono text-muted-foreground">{s.links} lien{s.links > 1 ? "s" : ""}</span>
            <span className="font-mono text-secondary inline-flex items-center gap-1"><Headphones size={11} /> {s.plays}</span>
            <span className="font-mono text-primary inline-flex items-center gap-1" title="Auditeurs uniques" data-testid={`scene-analytics-listeners-${s.title}`}><Users size={11} /> {s.listeners ?? 0}</span>
            <span className="font-mono text-amber-300 inline-flex items-center gap-1"><MessageSquare size={11} /> {s.comments - s.resolved} ouv. · {s.resolved} rés.</span>
            <span className="font-mono text-muted-foreground inline-flex items-center gap-1 w-full sm:w-auto" title="Première écoute publique" data-testid={`scene-analytics-first-${s.title}`}>
              <CalendarClock size={11} /> {s.first_listen ? `1ʳᵉ écoute ${fmtDate(s.first_listen)}` : "pas encore écoutée"}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
